<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'100px'"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.indexCode')" prop="indexCode">
            <BjInput
              v-model="queryParams.indexCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingIndexesList.remark')" prop="remark">
            <BjInput
              v-model="queryParams.remark"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
            <el-select
              v-model="queryParams.enabledFlag"
              class="full-width"
              :placeholder="$t('chooseText')"
              clearable
            >
              <el-option
                v-for="(item, index) in STATUS_ENABLED_NUM"
                :key="index"
                :label="$t(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-permission:SettingIndexesConfigListAdd
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="col.prop === 'enabledFlag'"
                :type="scope.row.enabledFlag === 1 ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.enabledFlag)) }}</el-tag
              >

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingIndexesConfigListEdit
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="props.row.enabledFlag === 0"
                v-permission:SettingIndexesConfigList_Status
                type="text"
                @click="onUpdata(props.row, 1)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-if="props.row.enabledFlag === 1"
                v-permission:SettingIndexesConfigList_Status
                type="text"
                @click="onUpdata(props.row, 0)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button type="text" @click="copy(props.row)">{{ $t('SettingIndexesList.copyIndex') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { settingApi } from '@/api';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'SettingIndexesConfigListIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      STATUS_ENABLED_NUM,
      queryApi: settingApi.getIndexesList,
      // 查询参数
      queryParams: {
        indexCode: null,
        remark: null,
        enabledFlag: null,
      },
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},
      labelsVersion: 11,
      labelList: [
        { label: 'SettingIndexesList.indexCode', prop: 'indexCode', isCheck: true, disabled: false},
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false},
        { label: 'SettingIndexesList.remark', prop: 'remark', isCheck: true, disabled: false },
        { label: 'table.createdByText', prop: 'createUser', isCheck: true, disabled: false},
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false},
        { label: 'SettingIndexesList.updateUser', prop: 'updateUser', isCheck: true, disabled: false},
        { label: 'SettingIndexesList.lastUpdateDate', prop: 'lastUpdateDate', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false},
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onAdd() {
      this.$router.push({
        name: 'SettingIndexesConfigListAdd',
        query: {},
      });
    },
    onEdit(row) {
      row = JSON.stringify(row);
      this.$router.push({
        name: 'SettingIndexesConfigListEdit',
        query: {
          form: row,
        },
      });
    },
    copy(row) {
      this.$copyText(row.indexCode).then(
        e => {
          this.msgSuccess(this.$t('ReplicationSucceededText'));
        },
        function(e) {
          this.msgError(this.$t('SettingIndexesList.msgError'));
        },
      );
    },
    onUpdata(row, enabledFlag) {
      settingApi
        .updataIndexes({
          indexId: row.indexId,
          indexCode: row.indexCode,
          enabledFlag: enabledFlag,
          _token: row._token,
        })
        .then(res => {
          if (!res.failed) {
            row.enabledFlag = enabledFlag;
            this.msgSuccess(this.$t('SettingIndexesList.msgSuccess'));
          }
        });
    },
    handleClose(done) {
      done();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  overflow: auto;
  padding: 30px;
}
// ::v-deep .el-drawer__container ::-webkit-scrollbar{
//     display: none;
// }
</style>
